import moment from "moment";

import {
  ENCRYPT_LOCAL_STORAGE,
  SELECT_EXPORT_PAGES,
  SESSION_EXPIRY_TIME,
} from "./Constants/common";
import { apiDecrypt, apiEncrypt } from "./utilities/keyEncryption";
import logger from "./utilities/logger";

export const lckey = "state";
/**
 * Loads the state from the local storage.
 *
 * @return {object | undefined} The parsed state object or undefined if not found.
 */
export const loadState = () => {
  try {
    const serializedState = _localGet(lckey);
    if (serializedState === null) {
      return undefined;
    }
    if (ENCRYPT_LOCAL_STORAGE) {
      return JSON.parse(apiDecrypt(serializedState));
    }
    return JSON.parse(serializedState);
  } catch {
    return undefined;
  }
};

function safeStringify(obj) {
  const seen = new WeakSet();
  return JSON.stringify(obj, (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  });
}

/**
 * Saves the state to local storage.
 *
 * @param {Object} state - the state to be saved
 * @return {void}
 */
export const saveState = (state) => {
  try {
    const serializedState = safeStringify(state);
    if (ENCRYPT_LOCAL_STORAGE) {
      _localSet(lckey, apiEncrypt(serializedState));
      return;
    }
    _localSet(lckey, serializedState);
  } catch (error) {
    // ignore write errors
  }
};

export const removeState = (state) => {
  _localRemove(lckey);
  _localRemove(`${lckey}_last_updated`);
  _localRemove("idleTimeout");
  _localRemove("c2Vzc2lvbg123123");
  Object.keys(SELECT_EXPORT_PAGES).forEach((key) => {
    _localRemove(`${SELECT_EXPORT_PAGES[key]}_reqData`);
  });
};

export const getLocalStorageState = () => {
  let state = _localGet("state");
  if (ENCRYPT_LOCAL_STORAGE) {
    return JSON.parse(apiDecrypt(state)) || null;
  } else {
    return JSON.parse(state) || null;
  }
};

export const checkStateExpiry = () => {
  const lastUpdated = _localGet(`${lckey}_last_updated`);
  if (!lastUpdated) {
    return false;
  }
  const lastUpdatedDate = moment(lastUpdated);
  const currentDate = moment();

  if (currentDate.diff(lastUpdatedDate, "minutes") > SESSION_EXPIRY_TIME) {
    return true;
  }
  return false;
};

export const _localSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    logger.error(error);
  }
};

export const _localGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    logger.error(error);
  }
};

export const _localRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    logger.error(error);
  }
};
